<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0010_device_embedded_information</div>
        <app-header>esma</app-header>
        <div :class="'container ' + pageContainerSize">
          <title-and-slot title="機器・組込情報" ></title-and-slot>
          <tabs nav-style="tabs" @active="onTabChanged($event)" :value="selectedTab">
            <tab header="使用中"></tab>
            <tab header="廃棄"></tab>
            <tab header="下書中/申請中/差戻"></tab>
          </tabs>
          <search-control
          style="padding-bottom: 10px;"
          :field_names="allSearchFields" @change="searchControlChangedDatasource"></search-control>
                    <div>
            <input
              @click="allChecked($event.target.value,$event.target)"
              style="float: right;"
              v-model="checkBoxSelectAll"
              :disabled="approveMode == 'reject'"
              type="checkbox" id="checkBoxSelectAll" name="checkBoxSelectAll" value="X">
          </div>
            <ag-grid-vue style="width: 100%; height: 325px" class="ag-blue" :gridOptions="gridOptions" ></ag-grid-vue>
          <br>
          <div style="float: left;;margin-top:5px">
            件数
            </div>
            <input type="text" data-cy="totalNumberOfRows" style="width: 5%;text-align: right;float: left;margin-left:5px" class="form-control limited-height-box" :disabled="true" :value="totalNumberOfRows" />
          <div style="margin-top:5px;">
             <button
             :disabled="formExportFileDisabled || checkUserPermission(true,permissionMode.EXPORT) == false"
             class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;background: #b83261;background: #337ab7;" @click="initExportFile" >出力</button>
             <button
             v-if="selectedTab == 2"
             :disabled="deleteBtnDisabled || checkUserPermission(true,permissionMode.DELETE) == false" 
             class="btn btn-primary" style="min-width:100px;float:right;margin-left: 10px;background: #FF7C80;border-color:#FF7C80;" @click="onDelete">{{deleteText}}</button>
            <button  :disabled="formBatchEditDisabled || checkUserPermission(true,permissionMode.EDIT) == false"
            class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;" @click="bachEdit" 
             >{{batchEditText}}</button>
            <button :disabled="checkUserPermission(true,permissionMode.ADD) == false" 
            class="btn btn-primary" style="min-width:100px;float: right;margin-left: 10px;background: #92D050;border-color:#92D050;" @click="addNew">新規</button>
             <!-- <a class="btn btn-warning" style="min-width:100px;float: right;margin-left: 10px;background: #b83261;background: #337ab7;" 
                  href='/api/device_embedded_information/export_data/'
                  target="device_embedded_information">出力</a> -->
          </div>
        </div>
        <device-embedded-information-bach-edit-modal tag="showDeviceEmbeddedInformationBachEditModal" @save="onDeviceEmbeddedInformationBachEditModalSave" @cloase="onDeviceEmbeddedInformationBachEditModalClose" />
        <file-download-modal tag="runDeviceEmbeddedInformationDownloadModal" @close="onCloseExportFile"/>
        <confirmation-modal tag="deleteDeviceEmbeddedInformationModal" @done="onConfirmDelete" />
        <information-icon-modal tag = "showInformationIconModalDeviceEmbededInformation"/>
    </div>
</template>

<script>
import Vue from 'vue';
import _ from 'lodash';
import uuid from "uuid";
import { AgGridVue } from 'ag-grid-vue';
import { fields, filed_types } from '@/rules/fields_device_embedded_information';
import deviceEmbeddedInformationBachEditModal from '@/components/modals/device-embedded-information-bach-edit-modal';
import { utils } from '@/libs/utils';
import _debug from 'debug';
var mdebug = _debug('esma:device_embedded_information');
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import { tab, tabs } from "vue-strap/dist/vue-strap.js";

import fileDownloadModal from '@/components/modals/file-download-modal';
import { bus } from '@/libs/bus';
export default {
  mixins: [
    mixinPageCommon,
    mixinDatasource
    ],
    components: {
    'ag-grid-vue': AgGridVue,
    'device-embedded-information-bach-edit-modal' : deviceEmbeddedInformationBachEditModal,
    'file-download-modal':fileDownloadModal,
    tab,
    tabs
  },
  data() {
    return {
      api_name:"device_embedded_information",
      page_acl: acl.device_embedded_information,
      execute_filter_on_back:true,
      detail_page:"page_0010_device_embedded_information_detail",
      link_to_open:"#",
      select_all:false,
      post_cached_timeout:30,
      selected_tab:0
    };
  },
  computed: {
    selectedTab:{
      get(){
        return this.selected_tab;
      },
      set(v){
        this.selected_tab = v;
      }
    },
    approveMode:{
      get(){
        return this.approve_mode;
      },
      set(v){
        this.approve_mode = v;
      }
    },
    checkBoxSelectAll:{
      get(){
        return this.select_all;
      },
      set(v){
        this.select_all = v;
      }
    },
    deleteBtnDisabled(){
      if(this.formOutputQty > 0 && this.isMaintenanceStaff == true){
        return false;
      }
      return this.formOutputQty == 0 ||  typeof _.find(this.selectedRowArr,(d)=>{ return d.device_control_number != "" && d.device_control_number != null}) != "undefined";
    },
    deleteText(){
      if(this.deleteBtnDisabled){
        return "削除";
      }else{
        return "削除 (" + this.formOutputQty + ")";
      }
    },
    linkToOpen:{
      get(){
        return this.link_to_open;
      },
      set(v){
        this.link_to_open = v;
      }
    },
    readOnly() {
      return this.read_only;
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    allFields(){
      return this.tabFieldList;
    },
    values() {
      console.log('values');
      return this.data_values;
    },
    allSearchFields(){
      return [
          fields.company,
          fields.approval_status,
          fields.device_control_number,
          fields.registration_date,
          fields.last_update_date,
          fields.computer_name,
          fields.equipment_in_charge_department,
          fields.equipment_in_charge_team,
          fields.equipment_in_charge_classification,
          fields.equipment_in_charge_system_it,
          fields.installation_department,
          fields.installation_team,
          fields.installation_base,
          fields.user_name,
          fields.management_person_name,
          fields.status
      ]
    },
    tabFieldList() {
      return [
        utils.extend(fields.company, {}),
        utils.extend(fields.approval_status, {}),
        utils.extend(fields.status, {}),
        utils.extend(fields.device_control_number, {tab_size:100}),
        utils.extend(fields.registration_date, {}),
        utils.extend(fields.last_update_date, {}),
        utils.extend(fields.computer_name, {}),
        utils.extend(fields.equipment_in_charge_department, {}),
        utils.extend(fields.equipment_in_charge_team, {}),
        utils.extend(fields.equipment_in_charge_classification, {}),
        utils.extend(fields.equipment_in_charge_system_it, {}),
        utils.extend(fields.installation_department, {}),
        utils.extend(fields.installation_team, {}),
        utils.extend(fields.installation_base, {}),
        utils.extend(fields.user_name, {}),
        utils.extend(fields.management_person_name, {}),
      ];
    }
  },
  methods: {
    onTabChanged(index) {
      this.checkBoxSelectAll = false;
      this.clearSearchFields();
      switch (index) {
        case 0:
        case "in_use":
          this.selectedTab = 0;
          this.api_request_options = {filter_mode:"使用中"};
          window.sessionStorage.setItem('device_back_to_list', "/device_embedded_information/tab/in_use") 
          this.$router.push({ name: "page_0010_device_embedded_information_tab", params: { mode: "in_use" } });
          break;
        case 1:
        case "disposal":
          this.selectedTab = 1;
          this.api_request_options = {filter_mode:"廃棄"};
          window.sessionStorage.setItem('device_back_to_list', "/device_embedded_information/tab/disposal") 
          this.$router.push({ name: "page_0010_device_embedded_information_tab", params: { mode: "disposal" } });
          break;
        case 2:
        case "pending":
          this.selectedTab = 2;
          this.api_request_options = {filter_mode:"下書中/申請中/差戻"};
          window.sessionStorage.setItem('device_back_to_list', "/device_embedded_information/tab/pending") 
          this.$router.push({ name: "page_0010_device_embedded_information_tab", params: { mode: "pending" } });
          break;
        default:
          return;
      }
      this.emulateSearchControlChangedDatasource(true)
    },

    allChecked(a,b){
      this.commonAllChecked("showInformationIconModalDeviceEmbededInformation")
    },
    hideCheckBox(data){
      return (data && (data.approval_status == "申請中"))
    },
    onDelete(){
      if(Array.isArray(this.selectedRowArr) == false || this.selectedRowArr.length == 0){
        return;
      }
      bus.$emit("deleteDeviceEmbeddedInformationModal",{
        title: "削除",
        message: "" + this.selectedRowArr.length + " 機器・組込情報の削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color:"danger",
        no_color:"info",
        model_height:"50"
      });
    },
    onConfirmDelete(mode){
      if(mode == "yes"){
        if(Array.isArray(this.selectedRowArr) == false || this.selectedRowArr.length == 0){
          return;
        }
        var arr = this.selectedRowArr.map((m)=>{return m.seq_id;})
        var vm = this
        this.commonDeleteArr(vm,arr,()=>{
          // All Deleted
          vm.formOutputQty = 0;
          vm.selectedRowArr = [];
        });
      }
    },
    initExportFile(){
      //FILE_EXPORT_PART2 : Step 2
      bus.$emit("runDeviceEmbeddedInformationDownloadModal",{
        message: "ファイルを出力しています。",
        on_complete_message:"出力が完了しました。",
        title: "出力",
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        api_request_options: this.api_request_options,
        sub_search:this.search_data,
        url:"/device_embedded_information/export_data/"
      });
    },
    onCloseExportFile(){},
    addNew(){
      return this.$router.push({ name: this.detail_page, params: {  seq_id:"new"} });
    },
    bachEdit(){
      var p_id = uuid.v4()
      var obj = {arr:this.selectedRowArr.map(m=>{return m.seq_id})}
      Vue.localStorage.set("bulk_edit_" + p_id, JSON.stringify(obj))
      return this.$router.push("/device_embedded_information/bulk_edit/" + p_id);
    },
    onDeviceEmbeddedInformationBachEditModalSave(result){
      console.log("onDeviceEmbeddedInformationBachEditModalSave data", {result});
    },
    onDeviceEmbeddedInformationBachEditModalClose(){
      console.log("onDeviceEmbeddedInformationBachEditModalSave");
    },
    // searchControlChangedDatasource(d,a,b,c){
    //   console.log(d,a,b,c)
    // },
    onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: "page_0010_device_embedded_information_detail", params: {  seq_id:data.seq_id} });
    },
    createColumnDefs() {
      return this.commonCreateColumnDefs({show_details:true,show_checkbox:true,force_sort:{id:"equipment_in_charge_department",direction:"asc"}})
    }
  },
  mounted() {
    this.selectedTab = this.$route.meta.tab_index;
    window.sessionStorage.setItem('device_back_to_list', "/device_embedded_information") 
    this.gridOptions.api.sizeColumnsToFit();
    if(this.$route.params.mode){
      this.onTabChanged(this.$route.params.mode)
    }
  },
  beforeDestroy() {
  },
  beforeMount() {
    this.count_from_result = true;
    this.$store.state[this.stateCurrentRow]= {};
    this.gridOptions = _.extend(this.commonGridOptions,{}) ;
    this.api_request_options = {filter_mode:"使用中"};
    this.initDatasource({load_only_with_filter:false});
  }
};

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// page_0010_device_embedded_information.vue?9ad8a77c